// Time-based personal greeting. Uses the visitor's LOCAL device time.
// Name is passed in from the user's saved profile only — never derived here.

const SLOTS = {
  morning: {
    icon: "☀️",
    en: [
      { line: "Good morning{name}", sub: "Let's make today a little easier." },
      { line: "Morning{name}", sub: "A fresh start — what can I help with?" },
      { line: "Good morning{name}", sub: "Here whenever you're ready." },
    ],
    hi: [
      { line: "सुप्रभात{name}", sub: "आज को थोड़ा आसान बनाते हैं।" },
      { line: "गुड मॉर्निंग{name}", sub: "नई शुरुआत — मैं किसमें मदद करूं?" },
    ],
  },
  afternoon: {
    icon: "✨",
    en: [
      { line: "Good afternoon{name}", sub: "Ready when you are." },
      { line: "Afternoon{name}", sub: "Let's get something done." },
      { line: "Good afternoon{name}", sub: "What's on your mind?" },
    ],
    hi: [
      { line: "नमस्कार{name}", sub: "जब आप तैयार हों।" },
      { line: "गुड आफ्टरनून{name}", sub: "चलिए कुछ पूरा करते हैं।" },
    ],
  },
  evening: {
    icon: "🌆",
    en: [
      { line: "Good evening{name}", sub: "Take a breath. Let's get something done." },
      { line: "Evening{name}", sub: "Winding down? I'm here to help." },
      { line: "Good evening{name}", sub: "What can I take off your plate?" },
    ],
    hi: [
      { line: "शुभ संध्या{name}", sub: "एक सांस लें। चलिए कुछ पूरा करते हैं।" },
      { line: "गुड ईवनिंग{name}", sub: "मैं मदद के लिए यहीं हूं।" },
    ],
  },
  night: {
    icon: "🌙",
    en: [
      { line: "Good night{name}", sub: "EVERMIN is here whenever you need it." },
      { line: "Evening{name}", sub: "Here whenever you need me." },
    ],
    hi: [
      { line: "शुभ रात्रि{name}", sub: "EVERMIN जब भी ज़रूरत हो, यहीं है।" },
    ],
  },
  late: {
    icon: "🌙",
    en: [
      { line: "Still up{name}?", sub: "EVERMIN is here whenever you need it." },
      { line: "Burning the midnight oil{name}?", sub: "I'm here whenever you need me." },
    ],
    hi: [
      { line: "अभी तक जाग रहे हैं{name}?", sub: "EVERMIN जब भी ज़रूरत हो, यहीं है।" },
    ],
  },
};

function slotForHour(h) {
  if (h >= 5 && h < 12) return "morning";
  if (h >= 12 && h < 17) return "afternoon";
  if (h >= 17 && h < 21) return "evening";
  if (h >= 21 || h < 1) return "night";
  return "late"; // 1am–5am
}

export function getGreeting(name, language = "en") {
  const slot = SLOTS[slotForHour(new Date().getHours())];
  const variants = slot[language] && slot[language].length ? slot[language] : slot.en;
  const pick = variants[Math.floor(Math.random() * variants.length)];
  const safeName = name && name.trim() ? `, ${name.trim().split(" ")[0]}` : "";
  return {
    line: pick.line.replace("{name}", safeName),
    sub: pick.sub,
    icon: slot.icon,
  };
}
